import * as React from 'react'
import { useSelectCustomFieldData } from '@user/store/customFields'
import { EditableCustomField } from '@user/components/CustomFields'

export function CustomFieldList() {
  const { customFields, customSettings } = useSelectCustomFieldData()

  return (
    <>
      {customFields.map((field) => {
        const fieldSetting = customSettings.find(
          (x) => x.customFieldId === field.id,
        )
        return (
          <EditableCustomField
            multiFieldGap
            key={field.id}
            field={field}
            margin="normal"
            fieldSetting={fieldSetting}
          />
        )
      })}
    </>
  )
}
